<div class="row">
    <div class="col-sm-8 col-sm-offset-2">
        <h2>Créer un compte</h2>
        <form [formGroup]='signUpForm' (ngSubmit)='onSubmit()'>
            <div class="form-group">
                <label for="email">Email</label>
                <input type="text" id="email" class="form-control" formControlName='email'>
            </div>
            <div class="form-group">
                <label for="password">Mot de passe</label>
                <input type="password" id="password" class="form-control" formControlName="password">
            </div>
            <div class="form-group">
                <label for="name">Nom de l'utilisateur</label>
                <input type="text" id="name" class="form-control" formControlName="name">
            </div>
            <mat-form-field appearance="fill">
                <mat-label for="service">Service</mat-label>
                    <mat-select class="form-select form-select-lg" id="service" formControlName='service'>
                        <mat-option selected value="Autre">...</mat-option>
                        <mat-option value="Marketing">Marketing</mat-option>
                        <mat-option value="Operation">Operation</mat-option>
                        <mat-option value="Prod">Prod</mat-option>
                        <mat-option value="Dev">Dev</mat-option>
                      </mat-select>  
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label for="profil">Profil</mat-label>
                    <mat-select class="form-select form-select-lg" id="profil" formControlName='profil'>
                        <mat-option selected value="utilisateur">Utilisateur</mat-option>
                      </mat-select>  
            </mat-form-field>
            <re-captcha
                (resolved)="resolved($event)"
                siteKey="6LdeGXAaAAAAAI3Z4xiilP7M4KrfrT4iqRdCVgx-"
            ></re-captcha>
            <button class="btn btn-primary" type="submit" [disabled]='signUpForm.invalid'>Créer mon compte</button>
        </form>
        <p class="text-danger">{{errorMessage}}</p>
    </div>
</div>